import { Component } from "@angular/core"
import { ActivatedRoute, Router } from "@angular/router"

@Component({
    selector: "app-filter-clear",
    templateUrl: "./filter-clear.component.html",
    styleUrls: ["./filter-clear.component.scss"],
    standalone: false,
})
export class FilterClearComponent {
    constructor(
        private router: Router,
        private activeRoute: ActivatedRoute
    ) {}

    public clearFilters() {
        const studentQueryParam: boolean = !!this.activeRoute.snapshot.queryParams.student
        const params: { page: unknown } = { page: null }
        if (studentQueryParam) {
            // @ts-ignore
            params.student = true
        }
        this.router.navigate([], { queryParams: params })
    }
}
